import { render, staticRenderFns } from "./OccupationsPage.vue?vue&type=template&id=3c91873c&scoped=true&"
import script from "./OccupationsPage.vue?vue&type=script&lang=js&"
export * from "./OccupationsPage.vue?vue&type=script&lang=js&"
import style0 from "./style.scss?vue&type=style&index=0&id=3c91873c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c91873c",
  null
  
)

export default component.exports